import { combineReducers } from "@reduxjs/toolkit";
import stochasticCustomersReducer from "../modules/stochastic/features/CustomerList/slices/stochasticCustomersSlice";
import stochasticProspectsReducer from "../modules/stochastic/features/ProspectList/slices/stochasticProspectsSlice";
import stochasticInvoicesReducer from "../modules/stochastic/features/InvoiceList/slices/stochasticInvoicesSlice";
import stochasticCampaignProductsReducer from "@/modules/stochastic/features/CampaignProductManagement/slices/campaignProductsSlice";
import userAppSettingsReducer from "../modules/hub/features/UserAppSettings/slices/userAppSettingsSlice";
import quickBooksReportsReducer from "../modules/hub/features/FinancialReports/slices/quickBooksReportsSlice";
import periodReportReducer from "../modules/hub/features/FinancialReports/slices/periodReportSlice";
import usersReducer from "../modules/hub/features/UserManagement/slices/usersSlice";
import companiesReducer from "../modules/hub/features/CompanyManagement/slices/companiesSlice";
import editUserDetailsReducer from "../modules/hub/features/UserManagement/slices/editUserDetailsSlice";
import companyProfileReducer from "../modules/hub/features/UserAppSettings/slices/companyProfileSlice";
import userProfileReducer from "../modules/hub/features/UserAppSettings/slices/userProfileSlice";
import campaignListReducer from "../modules/stochastic/features/CampaignManagement/slices/campaignListSlice";
import campaignReducer from "../modules/stochastic/features/CampaignManagement/slices/campaignSlice";
import campaignBatchListReducer from "../modules/stochastic/features/CampaignBatchManagement/slices/campaignBatchListSlice";
import batchReducer from "../modules/stochastic/features/CampaignBatchManagement/slices/batchSlice";
import batchProspectReducer from "../modules/stochastic/features/BatchProspectManagement/slices/batchProspectSlice";
import campaignFilesReducer from "../modules/stochastic/features/CampaignFileManagement/slices/campaignFilesSlice";
import createCampaignReducer from "../modules/stochastic/features/CampaignManagement/slices/createCampaignSlice";
import campaignDetailsReducer from "../modules/stochastic/features/CampaignManagement/slices/CampaignDetailsSlice";
import editRolesAndPermissionsReducer from "../modules/hub/features/UserManagement/slices/editRolesAndPermissionsSlice";
import fetchRestrictedAddressesReducer from "@/modules/stochastic/features/DoNotMailManagement/slices/fetchRestrictedAddressesSlice";
import createRestrictedAddressReducer from "@/modules/stochastic/features/DoNotMailManagement/slices/createRestrictedAddressSlice";
import updateRestrictedAddressReducer from "@/modules/stochastic/features/DoNotMailManagement/slices/updateRestrictedAddressSlice";
import deleteRestrictedAddressReducer from "@/modules/stochastic/features/DoNotMailManagement/slices/deleteRestrictedAddressSlice";
import fetchSingleRestrictedAddressReducer from "@/modules/stochastic/features/DoNotMailManagement/slices/fetchSingleRestrictedAddressSlice";
import resourceManagementMetadataReducer from "@/modules/hub/features/ResourceManagement/slices/resourceManagementMetadataSlice";
import createUpdateResourceReducer from "@/modules/hub/features/ResourceManagement/slices/createUpdateResourceSlice";
import resourceListReducer from "@/modules/hub/features/ResourceManagement/slices/resourceListSlice";
import emailTemplateListReducer from "@/modules/emailManagement/features/EmailTemplateManagement/slices/emailTemplateListSlice";
import emailTemplateReducer from "@/modules/emailManagement/features/EmailTemplateManagement/slices/emailTemplateSlice";
import emailTemplateVariableListReducer from "@/modules/emailManagement/features/EmailTemplateManagement/slices/emailTemplateVariableListSlice";
import resourceCategoryReducer from "@/modules/hub/features/ResourceCategoryManagement/slice/resourceCategorySlice";
import resourceTagReducer from "@/modules/hub/features/ResourceTagManagement/slice/resourceTagSlice";
import emailTemplateCategoryReducer from "@/modules/emailManagement/features/EmailTemplateCategoryManagement/slice/emailTemplateCategorySlice";
import employeeDirectorySpecialtyReducer from "@/modules/administration/features/EmployeeDirectoryManagement/slices/specialtySlice";
import employeeDirectoryTeamReducer from "@/modules/administration/features/EmployeeDirectoryManagement/slices/teamSlice";
import employeeProfileReducer from "@/modules/administration/features/EmployeeDirectoryManagement/slices/employeeProfileSlice";
import eventCategoryReducer from "@/modules/eventRegistration/features/EventCategoryManagement/slice/eventCategorySlice";
import emailCampaignReducer from "@/modules/emailManagement/features/EmailCampaignManagement/slices/emailCampaignSlice";
import emailCampaignListReducer from "@/modules/emailManagement/features/EmailCampaignManagement/slices/emailCampaignListSlice";
import emailCampaignStatusesReducer from "@/modules/emailManagement/features/EmailCampaignManagement/slices/emailCampaignStatusesSlice";
import emailCampaignEventLogListReducer from "@/modules/emailManagement/features/EmailEventLogsManagement/slices/emailCampaignEventLogListSlice";
import emailCampaignEventLogsMetadataReducer from "@/modules/emailManagement/features/EmailEventLogsManagement/slices/emailCampaignEventLogsMetadataSlice";
import eventDirectoryReducer from "@/modules/eventRegistration/features/EventDirectory/slices/eventDirectorySlice";
import createUpdateEventReducer from "@/modules/eventRegistration/features/EventManagement/slices/createUpdateEventSlice";
import eventListReducer from "@/modules/eventRegistration/features/EventManagement/slices/eventListSlice";
import createUpdateEventSessionReducer from "@/modules/eventRegistration/features/EventSessionManagement/slices/createUpdateEventSessionSlice";
import eventSessionListReducer from "@/modules/eventRegistration/features/EventSessionManagement/slices/eventSessionListSlice";
import eventSessionDayReducer from "@/modules/eventRegistration/features/EventSessionManagement/slices/eventSessionDaySlice";
import eventTagReducer from "@/modules/eventRegistration/features/EventTagManagement/slices/eventTagSlice";
import eventTypeReducer from "@/modules/eventRegistration/features/EventTypeManagement/slices/eventTypeSlice";
import wideSidebarReducer from "@/app/globalSlices/wideSidebarSlice";
import fileManagerDialogReducer from "@/app/globalSlices/fileManagerDialogSlice";
import appStripReducer from "@/app/globalSlices/appStripSlice";
import eventInstructorReducer from "@/modules/eventRegistration/features/EventInstructorManagement/slices/eventInstructorSlice";
import locationListReducer from "@/modules/stochastic/features/LocationsList/slices/locationListSlice";
import locationReducer from "@/modules/stochastic/features/LocationsList/slices/locationSlice";
import voucherListReducer from "@/modules/eventRegistration/features/EventVoucherManagement/slices/VoucherListSlice";
import voucherReducer from "@/modules/eventRegistration/features/EventVoucherManagement/slices/VoucherSlice";
import venueListReducer from "@/modules/eventRegistration/features/EventVenueManagement/slices/VenueListSlice";
import venueReducer from "@/modules/eventRegistration/features/EventVenueManagement/slices/VenueSlice";
import DiscountListReducer from "@/modules/eventRegistration/features/EventDiscountManagement/slices/DiscountListSlice";
import DiscountReducer from "@/modules/eventRegistration/features/EventDiscountManagement/slices/DiscountSlice";
import DiscountMetadataReducer from "@/modules/eventRegistration/features/EventDiscountManagement/slices/DiscountMetadataSlice";
import resourceLibraryReducer from "@/modules/hub/features/ResourceLibrary/slices/resourceLibrarySlice";
import StochasticDashboardReducer from "@/modules/stochastic/features/Reports/SCDashboard/slice/StochasticDashboardSlice";
import enrollmentsWaitlistReducer from "@/modules/eventRegistration/features/EventWaitlist/slices/enrollmentsWaitlistSlice";
import fileManagementReducer from "@/modules/hub/features/FileManagement/slices/fileManagementSlice";
import fileManagementTagReducer from "@/modules/hub/features/FileManagement/slices/fileManagementTagSlice";
import fileManagerMetadataReducer from "@/modules/hub/features/FileManagement/slices/fileManagerMetadataSlice";
import resourceLibraryMetadataReducer from "@/modules/hub/features/ResourceLibrary/slices/resourceLibraryMetadataSlice";
import DoNotMailImportReducer from "@/modules/stochastic/features/DoNotMailImport/slice/DoNotMailListImportSlice";
import eventTransactionsReducer from "@/modules/eventRegistration/features/EventWaitlist/slices/eventTransactionsSlice";
import podcastsReducer from "@/modules/hub/features/Podcasts/slices/podcastsSlice";
import podcastsMetadataReducer from "@/modules/hub/features/Podcasts/slices/podcastsMetadataSlice";
import partnerNetworkReducer from "@/modules/hub/features/PartnerNetwork/slices/partnerNetworkSlice";
import partnerNetworkMetadataReducer from "@/modules/hub/features/PartnerNetwork/slices/partnerNetworkMetadataSlice";
import newsReducer from "@/modules/hub/features/News/slices/newsSlice";
import searchReducer from "@/modules/hub/features/Search/slices/searchSlice";
import purgeInvoicesReducer from "@/modules/stochastic/features/PurgeInvoices/slices/purgeInvoicesSlice";
import roiDashboardReducer from "@/modules/stochastic/features/Reports/ROIDashboard/slice/roiDashboardSlice";
import campaignJobStatusDataReducer from "@/modules/administration/features/Stochastic/CampaignJobStatus/slices/campaignJobStatusDataSlice";
import campaignStatusDataReducer from "@/modules/administration/features/Stochastic/CampaignStatus/slices/campaignStatusDataSlice";
import campaignStatusMetadataReducer from "@/modules/administration/features/Stochastic/CampaignStatus/slices/campaignStatusMetadataSlice";
import campaignStatusDownloadCsvReducer from "@/modules/administration/features/Stochastic/CampaignStatus/slices/campaignStatusDownloadCsvSlice";
import bulkBatchStatusDetailsMetadataReducer from "@/modules/administration/features/Stochastic/CampaignJobStatus/slices/bulkBatchStatusDetailsMetadataSlice";
import membershipSkuReducer from "@/modules/hub/features/MembershipSkuManagement/slice/membershipSkuSlice";
import campaignBillingBatchesReducer from "@/modules/stochastic/features/CampaignBillingManagement/slices/campaignBillingBatchesSlice";
import weekSummaryReducer from "@/modules/stochastic/features/CampaignBillingManagement/slices/weekSummarySlice";
import invoicePreviewReducer from "@/modules/stochastic/features/CampaignBillingManagement/slices/invoicePreviewSlice";
import draftInvoiceReducer from "@/modules/stochastic/features/CampaignBillingManagement/slices/draftInvoiceSlice";
import totalAddressableMarketReducer from "@/modules/stochastic/features/TotalAddressableMarket/slices/totalAddressableMarketSlice";
import adminUsersReducer from "@/modules/administration/features/UserManagement/slices/adminUsersSlice";
import eventNotificationsReducer from "@/modules/administration/features/Events/Notifications/slices/eventNotificationsSlice";
import registrationsReportReducer from "@/modules/administration/features/Events/Reports/slices/registrationsReportSlice";
import rosterManagementReportReducer from "@/modules/administration/features/Events/Reports/slices/rosterManagementReportSlice";
import trainingHistoryReportReducer from "@/modules/administration/features/Events/Reports/slices/trainingHistoryReportSlice";
import vouchersReportReducer from "@/modules/administration/features/Events/Reports/slices/vouchersReportSlice";
import transactionHistoryReportReducer from "@/modules/administration/features/Events/Reports/slices/transactionHistoryReportSlice";
import sessionsReportReducer from "@/modules/administration/features/Events/Reports/slices/sessionsReportSlice";
import integrationsStatusReducer from "@/modules/hub/features/UserAppSettings/slices/integrationsStatusSlice";
import accountBillabilityReducer from "@/modules/stochastic/features/CampaignBillingManagement/slices/accountBillabilitySlice";
import subscriptionBillingDataReducer from "@/modules/stochastic/features/SubscriptionBillingManagement/slices/subscriptionBillingDataSlice";
import mpDashboardReducer from "@/modules/stochastic/features/Reports/MPDashboard/slice/mpDashboardSlice";
import productStoreCategoriesReducer from "@/modules/stochastic/features/ProductStore/slices/productStoreCategoriesSlice";
import productStoreProductsReducer from "@/modules/stochastic/features/ProductStore/slices/productStoreProductsSlice";
import productStoreCartReducer from "@/modules/stochastic/features/ProductStore/slices/productStoreCartSlice";
import productStoreOrdersReducer from "@/modules/stochastic/features/ProductStore/slices/productStoreOrdersSlice";

const rootReducer = combineReducers({
  stochasticCustomers: stochasticCustomersReducer,
  stochasticProspects: stochasticProspectsReducer,
  stochasticInvoices: stochasticInvoicesReducer,
  stochasticCampaignProducts: stochasticCampaignProductsReducer,
  userAppSettings: userAppSettingsReducer,
  quickBooksReports: quickBooksReportsReducer,
  periodReport: periodReportReducer,
  users: usersReducer,
  editUserDetails: editUserDetailsReducer,
  companies: companiesReducer,
  companyProfile: companyProfileReducer,
  userProfile: userProfileReducer,
  campaignList: campaignListReducer,
  campaign: campaignReducer,
  campaignBatchList: campaignBatchListReducer,
  batch: batchReducer,
  batchProspect: batchProspectReducer,
  campaignFiles: campaignFilesReducer,
  createCampaign: createCampaignReducer,
  campaignDetails: campaignDetailsReducer,
  emailTemplate: emailTemplateReducer,
  emailTemplateList: emailTemplateListReducer,
  emailTemplateVariableList: emailTemplateVariableListReducer,
  editRolesAndPermissions: editRolesAndPermissionsReducer,
  fetchRestrictedAddresses: fetchRestrictedAddressesReducer,
  createRestrictedAddress: createRestrictedAddressReducer,
  updateRestrictedAddress: updateRestrictedAddressReducer,
  deleteRestrictedAddress: deleteRestrictedAddressReducer,
  fetchSingleRestrictedAddress: fetchSingleRestrictedAddressReducer,
  resourceManagementMetadataReducer: resourceManagementMetadataReducer,
  createUpdateResource: createUpdateResourceReducer,
  resourceCategory: resourceCategoryReducer,
  resourceTag: resourceTagReducer,
  resourceList: resourceListReducer,
  emailTemplateCategory: emailTemplateCategoryReducer,
  employeeDirectorySpecialty: employeeDirectorySpecialtyReducer,
  employeeDirectoryTeam: employeeDirectoryTeamReducer,
  employeeProfile: employeeProfileReducer,
  eventCategory: eventCategoryReducer,
  emailCampaign: emailCampaignReducer,
  emailCampaignList: emailCampaignListReducer,
  emailCampaignStatuses: emailCampaignStatusesReducer,
  emailCampaignEventLogList: emailCampaignEventLogListReducer,
  emailCampaignEventLogsMetadata: emailCampaignEventLogsMetadataReducer,
  eventDirectory: eventDirectoryReducer,
  createUpdateEvent: createUpdateEventReducer,
  eventList: eventListReducer,
  createUpdateEventSession: createUpdateEventSessionReducer,
  eventSessionList: eventSessionListReducer,
  eventSessionDay: eventSessionDayReducer,
  eventTag: eventTagReducer,
  eventType: eventTypeReducer,
  wideSidebar: wideSidebarReducer,
  fileManagerDialog: fileManagerDialogReducer,
  appStrip: appStripReducer,
  eventInstructor: eventInstructorReducer,
  locationList: locationListReducer,
  location: locationReducer,
  voucherList: voucherListReducer,
  voucher: voucherReducer,
  venueList: venueListReducer,
  venue: venueReducer,
  discountList: DiscountListReducer,
  discount: DiscountReducer,
  discountMetadata: DiscountMetadataReducer,
  resourceLibrary: resourceLibraryReducer,
  stochasticDashboard: StochasticDashboardReducer,
  enrollmentsWaitlist: enrollmentsWaitlistReducer,
  fileManagement: fileManagementReducer,
  fileManagementTag: fileManagementTagReducer,
  fileManagerMetadata: fileManagerMetadataReducer,
  resourceLibraryMetadata: resourceLibraryMetadataReducer,
  doNotMailImport: DoNotMailImportReducer,
  eventTransactions: eventTransactionsReducer,
  podcasts: podcastsReducer,
  podcastsMetadata: podcastsMetadataReducer,
  partnerNetwork: partnerNetworkReducer,
  partnerNetworkMetadata: partnerNetworkMetadataReducer,
  news: newsReducer,
  search: searchReducer,
  purgeInvoices: purgeInvoicesReducer,
  roiDashboard: roiDashboardReducer,
  campaignStatusData: campaignStatusDataReducer,
  campaignJobStatusData: campaignJobStatusDataReducer,
  campaignStatusMetadata: campaignStatusMetadataReducer,
  campaignStatusDownloadCsv: campaignStatusDownloadCsvReducer,
  bulkBatchStatusDetailsMetadata: bulkBatchStatusDetailsMetadataReducer,
  membershipSku: membershipSkuReducer,
  campaignBillingBatches: campaignBillingBatchesReducer,
  weekSummary: weekSummaryReducer,
  invoicePreview: invoicePreviewReducer,
  draftInvoice: draftInvoiceReducer,
  adminUsers: adminUsersReducer,
  eventNotifications: eventNotificationsReducer,
  registrationsReport: registrationsReportReducer,
  rosterManagementReport: rosterManagementReportReducer,
  trainingHistoryReport: trainingHistoryReportReducer,
  vouchersReport: vouchersReportReducer,
  transactionHistoryReport: transactionHistoryReportReducer,
  sessionsReport: sessionsReportReducer,
  totalAddressableMarket: totalAddressableMarketReducer,
  integrationsStatus: integrationsStatusReducer,
  subscriptionBillingData: subscriptionBillingDataReducer,
  accountBillability: accountBillabilityReducer,
  mpDashboard: mpDashboardReducer,
  productStoreCategories: productStoreCategoriesReducer,
  productStoreProducts: productStoreProductsReducer,
  productStoreCart: productStoreCartReducer,
  productStoreOrders: productStoreOrdersReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
